var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDinersClub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 42,
    viewBox: "0 0 62 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 61,
    height: 41,
    rx: 5.5,
    fill: "#0059C2",
    stroke: "#ECEDF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.3614 19.8194C42.3614 24.0022 42.6364 27.7392 39.6124 30.2061C37.2654 32.1218 32.79 32.9149 29.5115 32.9149C22.0092 32.9149 17.396 27.2489 17.396 19.8194C19.2317 12.9404 23.1691 9.73026 30.6714 9.73026C33.9499 9.73026 35.7339 9.95465 38.0809 11.8704C41.1049 14.3373 42.3614 15.6367 42.3614 19.8194Z",
    fill: "#0059C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3614 19.8194C42.3614 24.0022 42.6364 27.7392 39.6124 30.2061C37.2654 32.1218 32.79 32.9149 29.5115 32.9149C22.0092 32.9149 17.396 27.2489 17.396 19.8194C19.2317 12.9404 23.1691 9.73026 30.6714 9.73026C33.9499 9.73026 35.7339 9.95465 38.0809 11.8704C41.1049 14.3373 42.3614 15.6367 42.3614 19.8194Z",
    fill: "#0059C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1953 9H29.5005C22.5961 9 17 14.4368 17 21.1446C17 27.8513 22.5961 33.2891 29.5004 33.2891H33.1952C40.0996 33.2891 45.6957 27.8513 45.6957 21.1446C45.6957 14.4368 40.0996 9 33.1953 9ZM29.5004 32.1282C23.257 32.1282 18.195 27.2102 18.195 21.1446C18.195 15.0789 23.2571 10.1609 29.5004 10.1609C35.7438 10.1609 40.806 15.0789 40.806 21.1446C40.806 27.2103 35.7439 32.1282 29.5004 32.1282Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8918 14.7239C24.2588 15.7342 22.395 18.2269 22.395 21.1441C22.395 24.0613 24.2588 26.5539 26.8918 27.5642V14.7239Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1076 14.7239V27.5642C34.7407 26.5539 36.6044 24.0613 36.6044 21.1441C36.6044 18.2269 34.7407 15.7342 32.1076 14.7239Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinersClub);
export default __webpack_public_path__ + "static/media/diners-club.81a1d1e95c1fd3a3f0a218096fce275c.svg";
export { ForwardRef as ReactComponent };